import loadable from '@/utils/loadable';
import LoadingIndicator from '@/utils/LoadingIndicator';

export default loadable(() => import('./P4RMap2'), {
  fallback: <LoadingIndicator />,
});
